"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkTarget = exports.protobufPackage = void 0;
exports.protobufPackage = "link";
/** Mirrors the target attribute in the `a` HTML element */
var LinkTarget;
(function (LinkTarget) {
    LinkTarget[LinkTarget["SELF"] = 0] = "SELF";
    LinkTarget[LinkTarget["BLANK"] = 1] = "BLANK";
    LinkTarget[LinkTarget["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LinkTarget || (exports.LinkTarget = LinkTarget = {}));
//# sourceMappingURL=link.js.map